<template>
    <div class="search-box">
        <el-form ref="searchFormRef" :inline="true" :model="formInline">
            <!-- 仅保留核心搜索字段：预约日期范围 -->
            <el-form-item label="预约日期" prop="date">
                <el-date-picker v-model="formInline.date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
    </div>

    <div class="table-box">
        <div class="table-btns">
            <el-button type="primary" @click="addFn">新增预约</el-button>
        </div>
        <!-- 理发预约列表 -->
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%">
            <el-table-column type="index" label="序号" align="center" width="90" />
            <el-table-column prop="appointmentDate" label="预约日期" align="center" />
            <el-table-column prop="appointmentTime" label="预约时段" align="center" />
            <el-table-column prop="remark" label="理发地点" align="center" />
            <el-table-column prop="limitNum" label="预约限制人数" align="center" />
            <el-table-column prop="extend1" label="已预约人数" align="center">
                <template #default="scope">
                    <div style="width: 100%;color: #409EFF;cursor: pointer;" @click="numFn(scope.row)">{{
                        scope.row.extend1 || 0 }}/{{ scope.row.limitNum }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <el-button type="primary" size="small" :disabled="scope.row.status == 2" @click="editFn(scope.row)">
                        修改
                    </el-button>
                    <el-button type="danger" size="small" @click="delFn(scope.row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <el-pagination class="pagination" v-model:current-page="currentPage" v-model:page-size="pageSize"
            :page-sizes="[10, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper" :total="total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 新增/修改预约弹窗 -->
    <el-dialog v-model="dialogVisible" append-to-body :close-on-click-modal="false" :width="700" :title="dialogTitle">
        <userAddEditDialog v-if="dialogVisible" ref="addEditDialogRef" @dialogClose="dialogClose" />
    </el-dialog>
    <!-- 新增/修改预约弹窗 -->
    <el-dialog v-model="dialogVisible1" append-to-body :close-on-click-modal="false" width="80%" title="已预约人员">
        <modelDialog v-if="dialogVisible1" ref="modelDialogRef" @dialogClose="dialogClose" />
    </el-dialog>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import userAddEditDialog from "./dialog/userAddEditDialog.vue"; // 对应之前的表单弹窗
import modelDialog from "./dialog/modelDialog.vue"; // 对应之前的表单弹窗
import service from "@/http/request.js";

// ===== 核心变量 =====
// 弹窗控制
const dialogVisible = ref(false);
const dialogVisible1 = ref(false);
const dialogTitle = ref("");
const addEditDialogRef = ref(null);
const modelDialogRef = ref(null);

// 表格数据
const tableData = ref([{}]);
const selectionTable = ref([]); // 批量选择的数据
const total = ref(0); // 总条数
const currentPage = ref(1); // 当前页
const pageSize = ref(10); // 每页条数

// 搜索表单
const formInline = reactive({
    date: null, // 预约日期范围
});
const searchFormRef = ref();

// ===== 方法 =====
// 新增预约
const addFn = () => {
    dialogVisible.value = true;
    dialogTitle.value = "新增";
};

// 编辑预约
const editFn = (row) => {
    dialogVisible.value = true;
    dialogTitle.value = "修改";
    nextTick(() => {
        addEditDialogRef.value.init(row); // 回显数据到弹窗表单
    });
};

// 删除单条预约
const delFn = (row) => {
    ElMessageBox.confirm(
        "请确认是否删除该记录？",
        "删除提示",
        {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
        }
    ).then(() => {
        _userDelete(row.id);
    }).catch(() => {
        ElMessage.info("已取消删除");
    });
};

// 实际删除接口调用
const _userDelete = (ids) => {
    service.delete('/health/web/appointmentInfo/delete/' + ids)
        .then(data => {
            console.log(data)
            if (data.data.code == 200) {
                ElMessage.success("删除成功！");
                _userList();
            }
        })
        .catch(err => {
            ElMessage({
                message: err.message,
                type: "error",
            });
        })
};

const numFn = (row) => {
    dialogVisible1.value = true;
    nextTick(() => {
        modelDialogRef.value.init(row); // 回显数据到弹窗表单
    });
};
// 弹窗关闭回调
const dialogClose = (flag) => {
    dialogVisible.value = false;
    if (flag) {
        onSubmit(); // 保存成功后刷新列表
    }
};

// 搜索查询
const onSubmit = () => {
    _userList();
};

// 重置搜索（如果需要可添加重置按钮）
const onReset = (formEl) => {
    formEl.resetFields();
    currentPage.value = 1;
    pageSize.value = 10;
    _userList();
};

// 分页大小改变
const handleSizeChange = (val) => {
    pageSize.value = val;
    _userList();
};

// 页码改变
const handleCurrentChange = (val) => {
    currentPage.value = val;
    _userList();
};

// 表格选择事件
const handleSelectionChange = (val) => {
    selectionTable.value = val;
};

// 获取预约列表数据
const _userList = () => {
    // 构造查询参数（和表单字段对应）
    const params = {
        pageSize: pageSize.value,
        pageNo: currentPage.value,
        startDate: formInline.date?.[0] || null, // 开始日期
        endDate: formInline.date?.[1] || null,   // 结束日期
    };

    service.post('/health/web/appointmentInfo/page', params)
        .then(data => {
            console.log(data)
            if (data.data.code == 200) {
                tableData.value = data.data.data.records
                total.value = data.data.data.total
            }
        })
        .catch(err => {
            ElMessage({
                message: err.message,
                type: "error",
            });
        })
};

// 挂载时加载列表
onMounted(() => {
    _userList();
});
</script>

<style scoped lang="scss">
// 状态文字样式
:deep(.el-table) {
    .brown {
        color: brown !important;
    }

    .green {
        color: green !important;
    }
}
</style>